export const MAX_LLAMA4_IMAGES = 5;

export const COMPOUND_MODELS = ["compound-beta", "compound-beta-mini"];

export const isTestOrg = (orgId: string) => {
  return (
    orgId === "org_01hqbd9y3fexcrngzqm9qh6ya9" ||
    orgId === "org_01hy1kbsr7e2ta16m2d01s3bdq"
  );
};

export const isJsonSchemaCapableModel = (model: string) => {
  return model.includes("llama-4");
};

export const modelForJsonSchema = "meta-llama/llama-4-scout-17b-16e-instruct";

export function isSpeechToText(model: string): boolean {
  const modelLower = model.toLowerCase();
  return modelLower.includes("whisper") || modelLower.includes("sautech");
}

export function isImageToText(model: string): boolean {
  return model.toLowerCase().includes("llava");
}

export function isTextToText(model: string): boolean {
  return !(
    isSpeechToText(model) ||
    isImageToText(model) ||
    isTextToSpeech(model)
  );
}

export function isTextToSpeech(model: string): boolean {
  return model.toLowerCase().includes("tts");
}

export const modelSupportsImageInMessages = (model: string): boolean => {
  return (
    (model.includes("llama") && model.includes("vision")) ||
    model.includes("quattro") ||
    model.includes("llama-4") ||
    model.includes("llama-guard-4")
  );
};

export const modelDoesNotSupportSystemPromptIfImageInMessages = (
  model: string,
): boolean => {
  return model.includes("llama") && model.includes("vision");
};

export const isPreviewModel = (model: string): boolean => {
  const previewModels = [
    "mock-llama3-model",
    "llama-3.1-8b-instant",
    "llama-3.1-70b-versatile",
    "llama-3.1-405b-reasoning",
  ];
  return previewModels.includes(model);
};

const emberglow = /^emberglow/i;
const openAIGptOss = /^openai\/gpt-oss/i;

export const modelUsesReasoningEffort = (model: string): false | string[] => {
  if (emberglow.test(model) || openAIGptOss.test(model)) {
    return ["low", "medium", "high"];
  }
  if (model.includes("qwen3")) {
    return ["default", "none"];
  }
  return false;
};

export const modelSupportsToolCodeInterpreter = (model: string): boolean => {
  return emberglow.test(model) || openAIGptOss.test(model);
};

export const modelSupportsToolBrowserSearch = (model: string): boolean => {
  return emberglow.test(model) || openAIGptOss.test(model);
};

export const modelSupportsToolMCP = (model: string): boolean => {
  return (
    openAIGptOss.test(model) ||
    emberglow.test(model) ||
    model.includes("qwen3") ||
    model.includes("llama-4") ||
    model.includes("kimi-k2")
  );
};

export function isGptOssModel(model: string) {
  return emberglow.test(model) || openAIGptOss.test(model);
}
